// tslint:disable
declare const $: any;
declare const System: any;

const themesSettingFunction = (function () {
    if (!(window as any).rtfThemesHasLoaded) {
        System.import('/platform/runtime/common/web/gsprtf/gsp.rtf.css.js?v=' + Date.now()).then(
            function () { console.log('换肤加载完成'); }
        ).catch(
            function (e) { console.log(e); }
        );
    }
}());
export { themesSettingFunction };
